type EmptyClass = undefined | null | ''

type ClassName = Record<string, boolean> | string | EmptyClass
type NonEmptyClass = Exclude<ClassName, EmptyClass>
function isNonEmptyClass(className: ClassName): className is NonEmptyClass {
  return Boolean(className)
}

/**
 * @param  {...(Object.<string, boolean> | string)} classes
 */
export function classNames(...classes: ClassName[]) {
  const trueClasses = classes
    .flat()
    .filter(isNonEmptyClass)
    .flatMap((nameOrDict) => {
      if (typeof nameOrDict === 'string') {
        return nameOrDict
      } else {
        return Object.entries(nameOrDict)
          .filter(([, val]) => val)
          .map(([name]) => name)
      }
    })
  return trueClasses.join(' ')
}
